<template>
  <v-app class="customFont">
    <v-app-bar
      app
      mx-0
      dark
      class="headerlup"
      max-width="100vw"
      clipped-left
      :color="offsetTop > 0 ? 'primary_dark' : 'transparent'"
      elevate-on-scroll
      height="100"
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        color="white"
      ></v-app-bar-nav-icon>
      <v-toolbar-title
        v-if="$router.currentRoute.name == 'Home'"
        class="headline text-uppercase"
      >
        <a
          href="#home"
          v-smooth-scroll="{
            duration: 1000,
            offset: -100,
            container: '',
            updateHistory: false,
          }"
        >
          <v-img
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            src="imagenes/logo.svg"
          ></v-img>
        </a>
      </v-toolbar-title>
      <v-toolbar-title v-else class="headline text-uppercase">
        <router-link to="/">
          <v-img
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '200' : '150'"
            contain
            :src="`imagenes/logo.svg`"
          ></v-img>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item
            class="my-5"
            @click="$router.push('/')"
            v-if="$route.path != '/'"
          >
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text">Inicio</a>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-5" @click="$router.push('/quienes-somos')">
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text"
                >Quiénes somos</a
              >
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-5" @click="$router.push('/personal-credit')">
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text"
                >Crédito Nómina</a
              >
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="my-5" @click="$router.push('/mipyme-credit')">
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text"
                >Crédito MIPYME</a
              >
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="my-5" @click="$router.push('/pyme-credit')">
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text"
                >Crédito PYME</a
              >
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="my-5" @click="$router.push('/faq')">
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text">F.A.Q.</a>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-5" v-if="$route.path == '/'">
            <v-list-item-title>
              <a
                class="v-btn v-btn--flat v-btn--text primary--text"
                href="#contacto"
                >Contacto</a
              >
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-5" @click="$router.push('/bolsa')">
            <v-list-item-title>
              <a class="v-btn v-btn--flat v-btn--text primary--text"
                >Bolsa de trabajo</a
              >
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-5" @click="loginModal = !loginModal">
            <v-list-item-title class="primary--text text-uppercase"
              >Iniciar sesión</v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <router-view />
    <v-dialog v-model="imagen" width="600">
      <v-card>
        <v-card-title class="bg-red">
          <v-layout justify-center align-center>
            <v-img max-width="180" :src="`imagenes/logo.svg`"></v-img>
          </v-layout>
        </v-card-title>
        <h2 class="text-center mt-5 black-font">
          <strong class="black-font">Comunicado</strong>
        </h2>
        <v-card-text class="font-weight-black text-center pa-10 black-font">
          <h2 class="font-weight-regular black-font">{{ textmodal }}</h2>
        </v-card-text>
        <v-divider></v-divider>
        <v-layout justify-center align-center>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="$store.dispatch('home/setModalImagen', false)"
              large
              color="primary_dark"
              class="boldFont"
              text
              >Entendido</v-btn
            >
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loginModal" width="600">
      <v-card>
        <v-card-text class="font-weight-black text-center pa-10 black-font">
          <h2 class="font-weight-regular black-font">
            Inicia sesión con tu cuenta
          </h2>
          <v-text-field
            label="Usuario"
            prepend-inner-icon="mdi-account"
            v-model="user"
          ></v-text-field>
          <v-text-field
            label="Contraseña"
            :type="isVisible ? 'text' : 'password'"
            prepend-inner-icon="mdi-lastpass"
            :append-icon="isVisible ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="isVisible = !isVisible"
            v-model="password"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-layout justify-center align-center>
          <v-card-actions>
            <v-btn
              large
              color="primary_dark"
              class="boldFont white--text mr-4"
              :loading="isLoadingSession"
              :disabled="isLoadingSession"
              @click="createUserWithPassword()"
              >Iniciar sesión</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              large
              color="primary_dark"
              class="boldFont"
              text
              @click="closeModalLogin()"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase";
export default {
  name: "App",
  data: () => ({
    offsetTop: 0,
    drawer: false,
    isVisible: false,
    loginModal: false,
    user: "",
    password: "",
    textmodal:
      "A través del presente hacemos del conocimiento de todos nuestros clientes, seguidores y público en general que Capitalica, es una empresa socialmente responsable de sus clientes, por lo que nuestros tramites son realizados de manera transparente y personalizados bajo nuestro proceso de Calidad: en los cuales, No solicitamos dinero por adelanto como anticipo para elaboración de solicitudes y/o autorización de créditos",
    publicPath: process.env.BASE_URL,
    isLoadingSession: false,
  }),
  computed: {
    ...mapState({
      imagen: (state) => state.home.imagen,
    }),
  },
  methods: {
    onScroll() {
      this.offsetTop = window.scrollY;
    },
    createUserWithPassword() {
      if (
        this.user == "" ||
        this.user == null ||
        this.password == "" ||
        this.password == null
      ) {
        alert("Usuario y contraseña requeridos");
      }
      let self = this;
      this.isLoadingSession = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user, this.password)
        .then(
          function(user) {
            /* eslint-disable no-console */
            console.log(user);
            /* eslint-enable no-console */
            self.isLoadingSession = false;
            self.loginModal = false;
            self.$router.push("/admin-site");
          },
          function() {
            self.isLoadingSession = false;
            alert("Usuario y/o contraseña incorrectos");
          }
        );
    },
    closeModalLogin() {
      this.user = "";
      this.password = "";
      this.loginModal = false;
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
<style scoped>
.bg-red {
  background-color: #8a172b !important;
}
.boldFont {
  font-weight: bolder !important;
}
.black-font {
  color: black !important;
}
.headerlup {
  position: fixed;
  right: 0;
  left: 0;
}
html {
  scroll-behavior: smooth;
}
.v-content {
  padding: 0px 0px 0px 0px !important;
}
.v-card {
  border-radius: 10px !important;
}
.customFont {
  font-family: "Eras Medium ITC" !important;
}

@font-face {
  font-family: "Eras Medium ITC";
  src: url("//db.onlinewebfonts.com/t/9fe52a19cf8e7f1077982f035f220fb9.eot");
  src: url("//db.onlinewebfonts.com/t/9fe52a19cf8e7f1077982f035f220fb9.eot?#iefix")
      format("embedded-opentype"),
    url("//db.onlinewebfonts.com/t/9fe52a19cf8e7f1077982f035f220fb9.woff2")
      format("woff2"),
    url("//db.onlinewebfonts.com/t/9fe52a19cf8e7f1077982f035f220fb9.woff")
      format("woff"),
    url("//db.onlinewebfonts.com/t/9fe52a19cf8e7f1077982f035f220fb9.ttf")
      format("truetype"),
    url("//db.onlinewebfonts.com/t/9fe52a19cf8e7f1077982f035f220fb9.svg#Eras")
      format("svg");
}
</style>
